<template>
    <form @submit.prevent="addUser">
        <div class="row">
            <div class="col-12 px-0">
                <ul class="qf-dashboard-navigation">
                    <li class="qf-active-nav">
                        <a href="#!" @click.prevent>
                            {{$ml.get('Data_Entry')}}
                        </a>
                    </li>
                    <li v-if="loading">
                        <a @clisk.prevent>
                            <font-awesome-icon icon="spinner" class="fa-spin"/>
                        </a>
                    </li>
                    <li></li>
                </ul>
            </div>
            <div class="col-12 pb-3">
                <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
            </div>
            <div class="col-12 pt-3">
                <div class="row justify-content-center">
                    <div class="col-12 col-sm-8 col-md-6">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="first_name">{{$ml.get('first_name')}}</label>
                                    <input type="text" class="form-control" name="first_name" id="first_name"
                                           :placeholder="$ml.get('first_name')" v-model="formData.first_name"
                                           v-validate="'required'" :class="{'is-invalid': errors.has('first_name')}">
                                    <small class="form-text text-danger pl-3"
                                           v-if="errorMessages.first_name.length">
                                        {{errorMessages.first_name}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="last_name">{{$ml.get('last_name')}}</label>
                                    <input type="text" class="form-control" name="last_name" id="last_name"
                                           :placeholder="$ml.get('last_name')" v-model="formData.last_name"
                                           v-validate="'required'" :class="{'is-invalid': errors.has('last_name')}">
                                    <small class="form-text text-danger pl-3"
                                           v-if="errorMessages.last_name.length">
                                        {{errorMessages.last_name}}
                                    </small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="roles">{{$ml.get('Role')}}</label>
                                    <select class="form-control" name="roles" id="roles" v-model="formData.roles[0]">
                                        <option value="ROLE_WRITE">{{$ml.get('Assistant')}}</option>
                                        <option value="ROLE_READ">{{$ml.get('TrademarkOwner')}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12" v-if="formData.roles[0]==='ROLE_READ'">
                                <div class="form-group">
                                    <label for="accessToBrandInput">{{$ml.get('AccessToTrademarkOwner')}}</label>
                                    <tags-input
                                            v-model="selectedOwners"
                                            :element-id="'accessToBrand'"
                                            :inputId="'accessToBrandInput'"
                                            :existing-tags="ownersTags"
                                            :typeahead="true"
                                            :typeahead-style="'dropdown'"
                                            :typeahead-activation-threshold="0"
                                            :only-existing-tags="true"
                                    ></tags-input>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="email">{{$ml.get('email')}}</label>
                                    <input type="email" class="form-control" name="email" id="email"
                                           :placeholder="$ml.get('email')" v-model="formData.email"
                                           v-validate="'required|email'" :class="{'is-invalid': errors.has('email')}">
                                    <small class="form-text text-danger pl-3"
                                           v-if="errorMessages.email.length">
                                        {{errorMessages.email}}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 pt-3">
                <div class="row justify-content-center" v-if="loading">
                    <div class="col text-center">
                        <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                    </div>
                </div>
                <div class="row justify-content-center" v-else>
                    <div class="col-3">
                        <a href="/dashboard" @click.prevent="$router.back()" class="btn btn-outline-dark w-100">{{$ml.get('Cancel')}}</a>
                    </div>
                    <div class="col-3">
                        <button class="btn btn-warning w-100" type="submit">
                            {{$ml.get('Save')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import TagsInput from '../../common/TagsInput'

    export default {
        name: "User",
        components: {
            TagsInput
        },
        computed: {
            ownersTags() {
                return this.owners.map(obj => {
                    return {key: obj.id, value: obj.name}
                });
            }
        },
        data() {
            return {
                selectedOwners: [],
                formData: {
                    first_name: '',
                    last_name: '',
                    roles: ['ROLE_WRITE'],
                    email: '',
                    owners: []
                },
                errorMessages: {
                    first_name: '',
                    last_name: '',
                    roles: '',
                    email: '',
                    monitoring: '',
                    password: '',
                    confirmPassword: '',
                },
                loading: false,
                id: false,
                writeAccess: false,
                loaders: {
                    owners: false
                },
                owner: -1,
                owners: [],
            }
        },
        beforeMount() {
            if (this.$route.params.id) {
                this.id = this.$route.params.id;
                this.getUser();
            }
        },
        mounted() {
            this.loaders.owners = true;
            this.$store.dispatch('owners').then(response => {
                this.owners = response;
                this.loaders.owners = false;
            });
        },
        methods: {
            getUser() {
                this.$store.dispatch('getUser', this.id).then(response => {
                    let owners = response.owner.map(obj => {
                        return obj.id;
                    });
                    this.selectedOwners = response.owner.map(obj => {
                        return {key: obj.id, value: obj.name};
                    });
                    this.formData = {
                        first_name: response.first_name,
                        last_name: response.last_name,
                        roles: response.roles,
                        email: response.email,
                        owners: owners
                    };
                });
            },
            addUser() {
                if (!this.loading) {

                    this.errorMessages = {
                        first_name: '',
                        last_name: '',
                        roles: '',
                        email: '',
                        monitoring: '',
                        password: '',
                        confirmPassword: '',
                    };
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            // this.formData.write_access = this.writeAccess;
                            if (this.id) {
                                let ownersArr = [];
                                this.selectedOwners.forEach(owner => {
                                    ownersArr.push(owner.key);
                                });
                                this.formData.owners = ownersArr;
                                this.$store.dispatch('editUser', {id: this.id, data: this.formData}).then(() => {
                                    this.loading = false;
                                    this.$router.back();
                                }).catch(error => {
                                    if (error.status === 400) {
                                        error.data.forEach(obj => {
                                            this.errorMessages[obj.property_path] = obj.message;
                                        });
                                    }
                                    this.loading = false;
                                });
                            } else {
                                this.$store.dispatch('createUser', this.formData).then(() => {
                                    this.loading = false;
                                    this.$router.push({name: 'UserList'});
                                }).catch(error => {
                                    if (error.status === 400) {
                                        error.data.forEach(obj => {
                                            this.errorMessages[obj.property_path] = obj.message;
                                        });
                                    }
                                    this.loading = false;
                                });
                            }
                        }
                    });
                }

            }
        }
    }
</script>

<style scoped>

</style>
